export const prompts = [
    "What’s a book or movie that has had a significant impact on you?",
    "If you could live anywhere in the world for a year, where would it be and why?",
    "What’s the most memorable trip you’ve ever taken?",
    "Who has been the most influential person in your life, and why?",
    "What’s something you’ve always wanted to learn but haven’t yet?",
    "If you could have dinner with any three people, living or dead, who would they be?",
    "What’s one thing on your bucket list you’re determined to accomplish?",
    "What’s a childhood memory that always makes you smile?",
    "What’s a personal trait or skill you’re most proud of?",
    "If you could relive any day in your life, which one would it be and why?",
    "What’s a piece of advice that has stuck with you over the years?",
    "What’s one thing you’re really grateful for today?",
    "If you had an extra hour every day, how would you spend it?",
    "What’s a hobby or activity that always brings you joy?",
    "What’s one habit or routine that keeps you grounded?",
    "If you could instantly master a skill, what would it be?",
    "What’s a goal or dream you’re currently working toward?",
    "What’s the most spontaneous thing you’ve ever done?",
    "What’s a compliment you’ve received that really meant a lot to you?",
    "If you could time travel to any period, past or future, when and where would you go?",
    "What’s a moment in your life that changed you forever?",
    "What do you believe is your greatest strength, and how has it shaped your journey?",
    "When was the last time you felt truly at peace, and what made it so meaningful?",
    "What’s a fear you’ve overcome, and how did it change you?",
    "What’s a mistake that taught you an important life lesson?",
    "If you could tell your younger self one thing, what would it be and why?",
    "What’s a relationship in your life that has profoundly shaped who you are?",
    "What’s a memory that you hold onto during tough times to keep you grounded?",
    "What’s something you’ve done that you never thought you were capable of doing?",
    "What do you think people misunderstand about you the most?",
    "If you could relive a single day, not to change it, but just to experience it again, what day would it be?",
    "What’s a belief or value that has guided you throughout your life?",
    "What’s something you’ve let go of that once held you back?",
    "What do you consider your life’s greatest accomplishment so far, and why?",
    "What’s the kindest thing anyone has ever done for you?",
    "How do you want to be remembered by the people closest to you?",
    "What’s a personal challenge you’re currently facing, and how are you navigating it?",
    "What does love mean to you, and how do you express it in your life?",
    "What’s a dream you’ve had to let go of, and how has that shaped your path?",
    "What’s one truth about yourself that you’re still learning to accept?",
    "What’s one thing you wish more people understood about you?",
    "What does success mean to you at this stage of your life?",
    "How do you handle feelings of failure or disappointment?",
    "What’s a core value that guides the way you live your life?",
    "How do you nurture your relationships when life gets busy?",
    "What’s one lesson you’ve learned from someone you admire?",
    "How do you decide when to follow your heart versus your head?",
    "What’s one thing you do that makes you feel deeply connected to yourself?",
    "What’s a fear you’ve overcome that you’re proud of?",
    "How do you bring meaning into your daily life?",
    "What’s one way you’ve grown emotionally in the past year?",
    "What’s a piece of advice that’s stuck with you for years?",
    "How do you express gratitude in your relationships?",
    "What’s something you’ve been learning about yourself recently?",
    "How do you recharge when you’re feeling drained?",
    "What’s one way you show love to the people who matter most to you?",
    "What’s something you’ve let go of that’s made your life better?",
    "How do you handle change when it feels overwhelming?",
    "What’s a decision you made that changed the course of your life?",
    "What’s one thing you hope to accomplish in the next year?",
    "How do you stay connected to your purpose during challenging times?",
    "What’s a dream you’ve never shared with anyone?",
    "What’s a memory that always makes you feel joyful?",
    "How do you approach making amends when you’ve hurt someone?",
    "What does self-care look like for you on a daily basis?",
    "What’s a belief or value you hold that others might find surprising?",
    "How do you handle situations where your values are challenged?",
    "What’s something you’ve achieved that you once thought was impossible?",
    "What does forgiveness mean to you, and how do you practice it?",
    "How do you define a fulfilling life?",
    "What’s one way you’ve become more resilient over the years?",
    "How do you stay grounded during moments of uncertainty?",
    "What’s a truth about yourself that you’ve come to accept recently?",
    "How do you show up for your friends when they’re struggling?",
    "What’s one habit or practice that helps you stay mentally healthy?",
    "How do you balance giving and receiving in your relationships?",
    "What’s a boundary you’ve set that’s improved your life?",
    "What’s one thing you’re currently working on improving about yourself?",
    "How do you approach building trust in your relationships?",
    "What’s a quality in others that you deeply admire?",
    "What’s a moment in your life that shaped who you are today?",
    "How do you decide what to prioritize when everything feels important?",
    "What’s a memory that reminds you of your inner strength?",
    "How do you approach expressing vulnerability in your relationships?",
    "What’s something you’ve done recently that brought you peace?",
    "How do you stay open to new perspectives or ideas?",
    "What’s a meaningful compliment you’ve received that you’ll never forget?",
    "What does love mean to you, and how do you express it?",
    "What’s one thing you do to stay connected to the people who matter most?",
    "How do you approach making difficult decisions in your life?",
    "What’s a moment of kindness you’ve experienced that deeply impacted you?",
    "How do you define personal growth, and what does it look like for you?",
    "What’s one thing you’ve done this year that took courage?",
    "How do you bring creativity into your life?",
    "What’s something that brings you hope when you’re feeling low?",
    "How do you approach conversations about difficult or sensitive topics?",
    "What’s one thing you’re currently grateful for that you didn’t appreciate before?",
    "How do you celebrate the small moments of joy in your life?",
    "What’s one way you’ve become more self-aware recently?",
    "How do you handle situations where you feel misunderstood?",
    "What’s a passion or interest that lights you up inside?",
    "How do you approach giving and receiving feedback in your relationships?",
    "What’s one thing you’ve done that you never thought you’d have the courage to do?",
    "How do you stay connected to your values during stressful times?",
    "What’s a piece of wisdom you’ve gained from an unexpected source?",
    "How do you approach building meaningful connections with new people?",
    "What’s something you’ve learned about yourself through your relationships?",
    "What does living an authentic life mean to you?",
    "How do you know when it’s time to let go of something or someone?",
    "What’s a moment in your life that taught you to be more compassionate?",
    "How do you ensure your actions align with your beliefs?",
    "What’s one thing you’ve done to bring more joy into your life?",
    "How do you express appreciation to the people around you?",
    "What’s a goal you’re working toward that feels deeply meaningful to you?",
    "How do you approach handling conflict in your relationships?",
    "What’s something you’ve learned about resilience through tough times?",
    "How do you stay connected to what matters most in your life?",
    "What’s a risk you’ve taken that turned out to be worthwhile?",
    "How do you stay curious about the world around you?",
    "What’s one way you’ve grown as a friend or partner recently?",
    "How do you approach finding balance in your life?",
    "What’s something you’ve done to step outside your comfort zone?",
    "How do you define inner peace, and what brings it to you?",
    "What’s one way you’ve become more confident in yourself over time?",
    "How do you approach giving second chances in your relationships?",
    "What’s a value you hold that influences your daily choices?",
    "How do you stay present during life’s busiest moments?",
    "What’s something you’ve done recently to strengthen a relationship?",
    "How do you handle feelings of regret or second-guessing?",
    "What’s one way you show up for yourself every day?",
    "How do you stay open to growth even when it’s uncomfortable?",
    "What’s a moment of connection with someone that left a lasting impression?",
    "How do you approach defining what truly matters in your life?",
    "What’s one thing you do to stay connected to your purpose?"
];
